var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinterSkullMRDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3535 28.7947C26.9376 28.7947 34.707 22.5587 34.707 14.8662C34.707 7.17373 26.9376 0.937744 17.3535 0.937744C7.76943 0.937744 0 7.17373 0 14.8662C0 22.5587 7.76943 28.7947 17.3535 28.7947Z",
    fill: "#F3F7BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30682 21.9446C9.57673 21.9446 11.4169 19.7978 11.4169 17.1495C11.4169 14.5013 9.57673 12.3545 7.30682 12.3545C5.0369 12.3545 3.19678 14.5013 3.19678 17.1495C3.19678 19.7978 5.0369 21.9446 7.30682 21.9446Z",
    fill: "#534437"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.377 21.9446C24.8991 21.9446 26.9437 19.7978 26.9437 17.1495C26.9437 14.5013 24.8991 12.3545 22.377 12.3545C19.8549 12.3545 17.8103 14.5013 17.8103 17.1495C17.8103 19.7978 19.8549 21.9446 22.377 21.9446Z",
    fill: "#534437"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6369 26.0545L5.93681 25.1411C5.93681 25.1411 3.65345 30.6212 8.22016 31.0778L16.4402 31.5345C16.4402 31.5345 20.0936 32.4478 19.6369 26.0545Z",
    fill: "#F3F7BB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8381 1.94714C26.6147 4.94291 28.309 8.91139 28.309 13.268C28.309 20.2231 23.9934 26.1918 17.8284 28.7857C27.1901 28.5802 34.7024 22.4289 34.7024 14.8664C34.7024 9.01643 30.2041 4.0113 23.8381 1.94714Z",
    fill: "#DCE29E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinterSkullMRDefault);
export default __webpack_public_path__ + "static/media/winter_skull_m_r_default.c210dd6bd3afd3e316ecaf0bc43c9863.svg";
export { ForwardRef as ReactComponent };